import {BaseModel} from "../base.model";
import { Product } from "./product.model";

export interface WholesaleProduct extends BaseModel {
    product?: Product;
    shopId?: string;
}

export const defaultWholesaleProduct: Readonly<WholesaleProduct> = {};